import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiUrl from "../Environment/Api";

function Login({ setAuth }) {
  const navigate = useNavigate();

  //   const [formData, setformData] = useState({
  //     email: "",
  //     password: "",
  //   });

  const [formData, setformData] = useState({
    username: "",
    password: "",
  });

  axios.defaults.withCredentials = true;

  const [message, setMessage] = useState("");
  //   const handlesubmit = async (e) => {
  //     e.preventDefault();
  //     try {
  //       const response = await axios.post(apiUrl + "/login", formData);
  //       console.log("Login response:", response.data);
  //       if (response.data.status === "success") {
  //         const token = response.data.token;
  //         localStorage.setItem("token", token);
  //         navigate("/dashboard");
  //         window.location.reload();
  //       } else {
  //         setMessage(response.data.message);
  //         console.log("Login failed:", response.data.message);
  //       }
  //     } catch (error) {
  //       alert("An error occurred while logging in. Please try again later.");
  //       console.error("Login error:", error);
  //     }
  //   };

  const handlesubmit = async (e) => {
    e.preventDefault();

    try {
      let payload = {};

      // email or editor_id
      if (formData.username.charAt(0).toLowerCase() === "a") {
        payload = {
          email: formData.username,
          password: formData.password,
        };
      } else {
        payload = {
          editor_id: formData.username,
          password: formData.password,
        };
      }

      const response = await axios.post(apiUrl + "/login", payload);

      console.log("Login response:", response.data);

      if (response.data.status === "success") {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.role);
        localStorage.setItem("name", response.data.name);
        localStorage.setItem("editor_id", response.data.editor_id);

        if (response.data.role === "admin") {
          navigate("/dashboard");
          setAuth(true);
        } else {
          navigate("/dashboard");
          setAuth(true);
        }
      } else {
        setMessage(response.data.message);
      }
    } catch (error) {
      console.log("ERROR:", error.response?.data);
      alert(error.response?.data?.message || "Login failed");
    }
  };

  return (
    <div>
      <div class="container-scroller ">
        <div class="page-body-wrapper full-page-wrapper backgroundimage">
          <div class="content-wrapper d-flex align-items-center auth">
            <div class="row flex-grow">
              <div class="col-lg-12 mx-auto">
                <div class="auth-form-light text-left p-5">
                  <div class="brand-logo">
                    {/* <h3>VAS PRODUCTION</h3> */}
                    <img
                      src={require("../../assets/img/Admin/vas-logo1-nav2.png")}
                      style={{ borderRadius: "50%" }}
                      alt="images"
                    />
                  </div>

                  <form onSubmit={handlesubmit} className="pt-3">
                    <div className="form-group">
                      <label>Username</label>
                      {/* <input
                        className="form-control form-control-lg"
                        id="exampleInputEmail1"
                        value={formData.email}
                        onChange={(e) =>
                          setformData({ ...formData, email: e.target.value })
                        }
                        placeholder="Username"
                      /> */}

                      <input
                        className="form-control form-control-lg"
                        value={formData.username}
                        onChange={(e) =>
                          setformData({ ...formData, username: e.target.value })
                        }
                        placeholder="User Name or Editor ID"
                      />
                    </div>
                    <div className="form-group">
                      <label>Password</label>
                      <input
                        type="password"
                        className="form-control form-control-lg"
                        id="exampleInputPassword1"
                        value={formData.password}
                        onChange={(e) =>
                          setformData({ ...formData, password: e.target.value })
                        }
                        placeholder="Password"
                      />
                    </div>
                    <p>{message}</p>
                    <div className="mt-3 login-button">
                      <button className="btn text-white bg-primary btn-lg font-weight-medium auth-form-btn">
                        SIGN IN
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- content-wrapper ends --> */}
        </div>
        {/* <!-- page-body-wrapper ends --> */}
      </div>
    </div>
  );
}

export default Login;
